import { render, staticRenderFns } from "./Scientific.vue?vue&type=template&id=783266d0&scoped=true"
import script from "./Scientific.vue?vue&type=script&lang=js"
export * from "./Scientific.vue?vue&type=script&lang=js"
import style0 from "./Scientific.vue?vue&type=style&index=0&id=783266d0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783266d0",
  null
  
)

export default component.exports